//Accounts for circular radius hoverable around the location pin
export const K_HOVER_CIRCLE_SIZE = 30;
// Accounts for the vertical height hovering on the location pin
export const K_PIN_STICK_SIZE = 1;
export const K_AGG_PIN_SIZE = -1;
